import React from 'react'
import Checkbox from '@material-ui/core/Checkbox'
import {
  FormLabel,
  Grid,
  GridJustification,
  makeStyles,
} from '@material-ui/core'

const useStyles = makeStyles({
  icon: {
    borderRadius: 3,
    width: 16,
    height: 16,
  },
})

type Props = {
  legendData: {
    label: string
    color: string
  }[]
  alignLegends?: GridJustification
}
export function Legends({
  legendData,
  alignLegends,
}: Props): React.ReactElement {
  const classes = useStyles()

  return (
    <Grid container justifyContent={alignLegends ?? 'flex-start'}>
      {legendData.map(({ label, color }) => (
        <Grid item key={label}>
          <Checkbox
            icon={
              <span
                className={classes.icon}
                style={{ backgroundColor: `${color}` }}
              />
            }
            checkedIcon={
              <span
                className={classes.icon}
                style={{ backgroundColor: `${color}` }}
              />
            }
            disabled
            disableFocusRipple
            disableRipple
          />
          <FormLabel>{label}</FormLabel>
        </Grid>
      ))}
    </Grid>
  )
}
